
import type { UserServiceListParams } from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'
import type { RegularFilter, UserRoleManagementMessages } from '../../models'
import { FilterTypeEnum } from '@empathybroker/tsclient-play/dist/enums/filter-type.enum'
import { computed, defineComponent } from 'vue'
import { useRoles } from '../../composables/users/use-roles'
import FiltersAside from '../filters/filters-aside.component.vue'

export default defineComponent({
  name: 'UsersFilters',
  components: {
    FiltersAside,
  },
  props: {
    value: {
      type: Object as PropType<UserServiceListParams['filters']>,
      required: true,
    },
    messages: {
      type: Object as PropType<UserRoleManagementMessages['filters']>,
      required: true,
    },
  },
  emits: {
    input: (value: UserServiceListParams['filters']) => {},
  },
  setup(
    props: {
      value: UserServiceListParams['filters']
      messages: UserRoleManagementMessages['filters']
    },
    { emit },
  ) {
    const {
      data: { list: rolesData },
    } = useRoles()

    const baseClass = 'epb-users-filters'

    const filters = computed<Record<string, RegularFilter>>(() => ({
      roleId: {
        config: {
          id: 'roleId',
          type: FilterTypeEnum.REGULAR,
          prettyName: props.messages.role.label,
          values:
            rolesData.value?.results.map(role => ({
              id: `${role.id}`,
              prettyName: role.name,
            })) ?? [],
          multiselectDisabled: true,
        },
        selectedValues: props.value.roleId !== undefined ? [`${props.value.roleId}`] : [],
      },
    }))

    function accept(filterSelectedValues): void {
      emit(
        'input',
        filterSelectedValues.roleId?.length
          ? { roleId: Number(filterSelectedValues.roleId[0]) }
          : {},
      )
    }

    return {
      baseClass,
      filters,
      accept,
    }
  },
})
